import { useRef, useEffect } from 'react';

const useActivityTracker = ({ intervalWait, trackerIsActive, callback }) => {
  // We can call this Hook to determine if the user has interacted with the page
  // in a certain Time, in case something happen, the tracking will stop
  // and we can define what will be triggered once the time has been completed

  // The props define the following:
  // intervalWait: Define how much time we'll wait until the callback is called
  // trackerIsActive: Define if we should keep tracking after the callback is called or not, in case you don't want to, just put it as true always
  // callback: The function that will be triggered once the time has been reached

  const INITIAL_WAIT = 3000;

  const EVENTS = ['mouseup', 'mousemove', 'scroll', 'keydown'];

  // We use ref to track and manage always only one timer
  const timerRef = useRef(null);

  const resetTracker = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(callback, INITIAL_WAIT + intervalWait);
  };

  useEffect(() => {
    const resetTrackerAndListen = () => resetTracker();

    // Add or remove event listeners based on the trackerIsActive prop
    if (trackerIsActive) {
      EVENTS.forEach(event => {
        window.addEventListener(event, resetTrackerAndListen);
      });
    } else {
      EVENTS.forEach(event => {
        window.removeEventListener(event, resetTrackerAndListen);
      });
      clearTimeout(timerRef.current);
    }

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      EVENTS.forEach(event => {
        window.removeEventListener(event, resetTrackerAndListen);
      });
      clearTimeout(timerRef.current);
    };
  }, [trackerIsActive, intervalWait]); // Added dependencies
};

export default useActivityTracker;
